import { render, staticRenderFns } from "./review-card-loader.vue?vue&type=template&id=73774769&scoped=true"
import script from "./review-card-loader.vue?vue&type=script&lang=js"
export * from "./review-card-loader.vue?vue&type=script&lang=js"
import style0 from "./review-card-loader.vue?vue&type=style&index=0&id=73774769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73774769",
  null
  
)

export default component.exports